import { PropertyRepository, PropertyWithRelations } from "@/repositories/properties.repository.ts";
import {
  AppointmentsRepository,
  AppointmentJoin,
  AppointmentFilterOptions,
} from "@/repositories/appointments.repository.ts";
import { uuid } from "@/interfaces";
import { Property } from "@/models/properties.model.ts";
import { appointment_status } from "@/models/appointment.model.ts";
import { ReadAllResponse } from "@/interfaces";

export async function deleteProperty(id: uuid): Promise<void> {
  return PropertyRepository.delete(id);
}

export async function findProperty(id: uuid): Promise<PropertyWithRelations> {
  return PropertyRepository.find(id);
}

export async function updatePropertyDetails(id: uuid, payload: Partial<Property>): Promise<Property> {
  return PropertyRepository.updateDetails(id, payload);
}

export async function setPropertyImage(id: uuid, image: File): Promise<Property> {
  return PropertyRepository.setImage(id, image);
}

export async function listPropertyAppointments(
  propertyId: uuid,
  page: number = 1,
  pageSize: number = 10,
  filters: {
    status?: appointment_status;
    serviceParent?: string;
    assignee?: string;
    search?: string;
  },
  sortKey: string = "created_at",
  sortOrder: "asc" | "desc" = "desc"
): Promise<ReadAllResponse<AppointmentJoin>> {
  return AppointmentsRepository.listForProperty(propertyId, page, pageSize, filters, sortKey, sortOrder);
}

export async function listPropertyAppointmentFilterOptions(propertyId: uuid): Promise<AppointmentFilterOptions> {
  return AppointmentsRepository.listFilterOptionsForProperty(propertyId);
}
